import React from 'react';
import ValuationTableHeader from './Header';

/**
 * @param {{children: JSX.Element; isGated?: boolean}} props
 * @returns {JSX.Element}
 */
function ValuationsContent(props) {
	return (
		<React.Fragment>
			<ValuationTableHeader isGated={props.isGated ?? false} />

			{props.children}
		</React.Fragment>
	);
}

export default React.memo(ValuationsContent);
